import React from 'react'
import PricingToggle from './PricingToggle'

const PricingHeader = ({ title, editions, professionalMode, handleProfessionalModeChange }) => {
    return (
        <div className="border-t border-dashed border-gray-accent-light pt-4">
            <p className="m-0 mt-1.5 mb-0 px-4 font-bold">{title}</p>
            <PricingToggle
                professionalMode={professionalMode}
                handleProfessionalModeChange={handleProfessionalModeChange}
                editions={editions}
            />
            {!professionalMode && <p className="m-0 mt-1.5 mb-0 text-sm ">{editions?.[0]?.description}</p>}
            {professionalMode && <p className="m-0 mt-1.5 mb-0 text-sm "> {editions?.[1]?.description}</p>}
        </div>
    )
}

export default PricingHeader
